export default {"src":"/login-app/[GIT_HASH]/_next/static/media/roots.35d0e4f4.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};